(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wgh-cart-behavior"] && !Shopify.designMode) return;
  try {
    (() => {
  customElements.whenDefined('drawer-content').then(() => {
    const cartSurface = Base => class extends Base {
      connectedCallback() {
        super.connectedCallback?.();
        this.version = 0;
        this.busy = false;
        this.events = new AbortController();
        const signal = this.events.signal;
        document.documentElement.addEventListener('cart:refresh', event => this.refresh(event).catch(() => this.showError()), {signal});
        this.addEventListener('click', event => this.handleClick(event), {signal});
        this.addEventListener('change', event => this.handleChange(event), {signal});
        this.addEventListener('keydown', event => {
          if (event.key === 'Enter' && event.target.matches('[data-wgh-quantity] input')) {
            event.preventDefault();
            this.handleChange(event);
          }
        }, {signal});
        this.addEventListener('submit', event => this.handleSubmit(event), {signal});
      }
      disconnectedCallback() {
        this.events?.abort();
        this.version++;
        if (this.open) this.open = false;
        super.disconnectedCallback?.();
      }
      get isDrawer() { return this.localName === 'wgh-cart-drawer'; }
      get cartRoute() { return window.themeVariables.routes.cartUrl; }
      showError(message) {
        const box = this.querySelector('[data-wgh-cart-error]');
        if (!box) return;
        box.querySelector('[data-wgh-error-text]').textContent = message || this.dataset.error;
        box.hidden = false;
      }
      setBusy(busy) {
        this.busy = busy;
        this.setAttribute('aria-busy', String(busy));
        this.querySelectorAll('[data-wgh-stack-upgrade] button, [data-wgh-upsell] button, [data-wgh-upsell] select, [data-wgh-quantity] input, button[name="checkout"]').forEach(control => {
          if (busy && !control.disabled) {
            control.dataset.wghBusyDisabled = 'true';
            control.disabled = true;
          } else if (!busy && control.dataset.wghBusyDisabled) {
            control.disabled = false;
            delete control.dataset.wghBusyDisabled;
          }
        });
      }
      async request(url, options = {}) {
        const response = await fetch(url, {credentials: 'same-origin', ...options});
        const data = await response.json();
        if (!response.ok) {
          const message = typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : this.dataset.error;
          throw new Error(message);
        }
        return data;
      }
      async refresh(event = {}) {
        const version = ++this.version;
        const detail = event.detail || {};
        let html = detail.cart?.sections?.[this.getAttribute('section')];
        if (!html) {
          const url = new URL(this.cartRoute, location.origin);
          url.searchParams.set('section_id', this.getAttribute('section'));
          const response = await fetch(url, {credentials: 'same-origin', cache: 'no-store'});
          if (!response.ok) throw new Error(this.dataset.error);
          html = await response.text();
        }
        if (!this.isConnected || version !== this.version) return;
        const replacement = new DOMParser().parseFromString(html, 'text/html').querySelector(this.localName);
        if (!replacement) throw new Error(this.dataset.error);
        const scrollTop = this.querySelector('.drawer__content')?.scrollTop || 0;
        const active = document.activeElement;
        const focusedInside = this.contains(active);
        const focusId = active?.id;
        const focusKey = active?.closest('[data-wgh-quantity]')?.dataset.lineKey;
        const focusAction = active?.dataset.wghAction;
        const focusDevice = active?.closest('[data-wgh-quantity]')?.dataset.device;
        const note = this.querySelector('textarea[name="note"]');
        const noteValue = note?.value;
        const noteOpen = this.querySelector('#cart-note')?.hasAttribute('open');
        const shippingState = Array.from(this.querySelectorAll('.shipping-estimator input,.shipping-estimator select')).map(input => ({id: input.id,value: input.value}));
        this.querySelectorAll('[data-wgh-persistent]').forEach(node => {
          const counterpart = Array.from(replacement.querySelectorAll('[data-wgh-persistent]')).find(next => next.dataset.wghPersistent === node.dataset.wghPersistent);
          if (counterpart) counterpart.replaceWith(node);
        });
        this.replaceChildren(...Array.from(replacement.childNodes));
        const content = this.querySelector('.drawer__content');
        if (content) content.scrollTop = scrollTop;
        if (noteValue !== undefined) {
          const nextNote = this.querySelector('textarea[name="note"]');
          if (nextNote) nextNote.value = noteValue;
          if (noteOpen) {
            this.querySelector('#cart-note')?.setAttribute('open','');
            this.querySelector('[aria-controls="cart-note"]')?.setAttribute('aria-expanded','true');
          }
        }
        for (const state of shippingState) {
          const input = this.querySelector('#' + CSS.escape(state.id));
          if (input) { input.value = state.value; if (input.matches('[is="country-selector"]')) input.dispatchEvent(new Event('change', {bubbles:true})); }
        }
        if (detail.openMiniCart && this.isDrawer) this.open = true;
        if (focusedInside && (!this.isDrawer || this.open)) {
          const sameRow = focusKey && Array.from(this.querySelectorAll('[data-wgh-quantity]')).find(row => row.dataset.lineKey === focusKey && row.dataset.device === focusDevice);
          const target = (focusId && this.querySelector('#' + CSS.escape(focusId))) || (sameRow && (focusAction ? sameRow.querySelector('[data-wgh-action="' + focusAction + '"]') : sameRow.querySelector('input'))) || this.querySelector('.drawer__close-button, h1');
          if (this.busy) this.pendingFocus = target;
          else target?.focus({preventScroll: true});
        }
        if (this.busy) this.setBusy(true);
        this.dispatchEvent(new CustomEvent('wgh:cart-rendered', {bubbles: true}));
      }
      handleClick(event) {
        const control = event.target.closest('[data-wgh-action]');
        if (!control || !this.contains(control)) return;
        event.preventDefault();
        if (this.busy) return;
        const row = control.closest('[data-wgh-quantity]');
        const current = Number(row.querySelector('input').value);
        const quantity = control.dataset.wghAction === 'remove' ? 0 : current + (control.dataset.wghAction === 'increase' ? 1 : -1);
        this.changeQuantity(row, quantity);
      }
      handleChange(event) {
        const select = event.target.closest('[data-wgh-upsell-variant]');
        if (select) {
          const price = select.closest('form').querySelector('[data-wgh-upsell-price]');
          if (price) price.textContent = select.selectedOptions[0].dataset.price;
          return;
        }
        const input = event.target.closest('[data-wgh-quantity] input');
        if (input) {
          if (this.busy) return;
          const quantity = Number(input.value);
          if (input.value.trim() === '' || !Number.isSafeInteger(quantity) || quantity < 0) {
            input.value = input.defaultValue;
            this.showError(this.dataset.quantityError);
            return;
          }
          this.changeQuantity(input.closest('[data-wgh-quantity]'), quantity);
        }
      }
      handleSubmit(event) {
        const form = event.target;
        if (form.matches('[data-wgh-stack-upgrade]')) {
          event.preventDefault();
          if (this.busy) return;
          this.upgradeStack(form);
        } else if (form.matches('[data-wgh-upsell]')) {
          event.preventDefault();
          if (this.busy || !form.reportValidity()) return;
          const data = new FormData(form);
          data.set('sections', this.getAttribute('section'));
          data.set('sections_url', location.pathname);
          this.mutate(async () => {
            const added = await this.request(window.themeVariables.routes.cartAddUrl + '.js', {method: 'POST', body: data, headers: {'X-Requested-With': 'XMLHttpRequest'}});
            this.dispatchEvent(new CustomEvent('variant:added', {bubbles: true, detail: {variant: added.items?.[0] || added}}));
            const cart = await this.request(this.cartRoute + '.js', {cache: 'no-store'});
            cart.sections = added.sections;
            return cart;
          });
        } else if ((form.id === 'mini-cart-form' || form.id === 'wgh-cart-page-form') && this.busy) event.preventDefault();
      }
      upgradeStack(form) {
        const variantId = Number(form.dataset.stackVariant);
        const stackProductId = Number(form.dataset.stackProduct);
        const keys = JSON.parse(form.dataset.replaceKeys);
        this.mutate(async () => {
          const original = await this.request(this.cartRoute + '.js', {cache: 'no-store'});
          const replacements = keys.map(key => original.items.find(item => item.key === key));
          if (original.items.some(item => item.product_id === stackProductId) || replacements.some(item => !item)) {
            throw new Error(form.dataset.changed);
          }
          const sameLine = (a, b) => {
            const properties = value => JSON.stringify(Object.entries(value || {}).sort(([a], [b]) => a.localeCompare(b)));
            return a.variant_id === b.variant_id && a.selling_plan_allocation?.selling_plan?.id === b.selling_plan_allocation?.selling_plan?.id && properties(a.properties) === properties(b.properties);
          };
          await this.request(window.themeVariables.routes.cartAddUrl + '.js', {
            method: 'POST', headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({items: [{id: variantId, quantity: 1}]})
          });
          try {
            const added = await this.request(this.cartRoute + '.js', {cache: 'no-store'});
            const updates = {};
            for (const source of replacements) {
              const line = added.items.find(item => item.key === source.key) || added.items.find(item => sameLine(item, source));
              if (!line || line.quantity !== source.quantity) throw new Error(form.dataset.partial);
              updates[line.key] = line.quantity - 1;
            }
            const cart = await this.request(this.cartRoute.replace(/\/$/, '') + '/update.js', {
              method: 'POST', headers: {'Content-Type': 'application/json'},
              body: JSON.stringify({updates, sections: [this.getAttribute('section')], sections_url: location.pathname})
            });
            for (const source of replacements) {
              const quantity = cart.items.filter(item => sameLine(item, source)).reduce((sum, item) => sum + item.quantity, 0);
              if (quantity !== source.quantity - 1) throw new Error(form.dataset.partial);
            }
            return cart;
          } catch (error) {
            throw new Error(form.dataset.partial);
          }
        });
      }
      changeQuantity(row, quantity) {
        if (!Number.isSafeInteger(quantity) || quantity < 0) return;
        const key = row.dataset.lineKey;
        this.mutate(() => this.request(window.themeVariables.routes.cartChangeUrl + '.js', {
          method: 'POST', headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({id: key, quantity, sections: [this.getAttribute('section')], sections_url: location.pathname})
        }));
      }
      async mutate(operation) {
        if (this.busy) return;
        this.setBusy(true);
        this.querySelector('[data-wgh-cart-error]').hidden = true;
        try {
          const cart = await operation();
          await this.refresh({detail: {cart}});
          document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {bubbles: true, detail: {cart}}));
          const status = this.querySelector('[data-wgh-cart-status]');
          if (status) status.textContent = this.dataset.updated;
        } catch (error) {
          try { await this.refresh(); } catch (_) {}
          this.showError(error.message);
        } finally {
          this.setBusy(false);
          if ((!this.isDrawer || this.open) && this.pendingFocus?.isConnected) this.pendingFocus.focus({preventScroll: true});
          this.pendingFocus = null;
        }
      }
    };
    if (!customElements.get('wgh-cart-drawer')) customElements.define('wgh-cart-drawer', cartSurface(customElements.get('drawer-content')));
    if (!customElements.get('wgh-cart-page')) customElements.define('wgh-cart-page', cartSurface(HTMLElement));
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wgh-mega-menu"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('wgh-mega-menu')){
  customElements.define('wgh-mega-menu',class extends HTMLElement{
    connectedCallback(){
      this.item=this.parentElement;
      this.navigation=this.closest('desktop-navigation');
      this.trigger=this.item.querySelector('.header__linklist-link');
      this.toggle=this.item.querySelector('.wgh-mega-toggle');
      if(!this.navigation||!this.trigger||!this.toggle)return;
      this.open=()=>{
        this.navigation.querySelectorAll('[data-wgh-mega-item]').forEach(item=>{
          if(item!==this.item&&item.querySelector('.header__linklist-link')?.getAttribute('aria-expanded')==='true')this.navigation.closeDropdown(item);
        });
        this.navigation.openDropdown(this.item);
      };
      this.onToggle=()=>{if(this.hasAttribute('hidden'))this.open();else this.navigation.closeDropdown(this.item);};
      this.onKey=(event)=>{
        if(event.key==='Escape'&&!this.hasAttribute('hidden')){
          event.preventDefault();event.stopPropagation();this.navigation.closeDropdown(this.item);this.toggle.focus();
        }else if(event.key==='ArrowDown'&&(event.target===this.trigger||event.target===this.toggle)){
          event.preventDefault();this.open();clearTimeout(this.focusTimer);this.focusTimer=setTimeout(()=>this.querySelector('a')?.focus(),180);
        }
      };
      this.onFocusOut=()=>{clearTimeout(this.blurTimer);this.blurTimer=setTimeout(()=>{if(!this.item.contains(document.activeElement)&&!this.item.matches(':hover'))this.navigation.closeDropdown(this.item);},0);};
      this.toggle.addEventListener('click',this.onToggle);
      this.item.addEventListener('keydown',this.onKey);
      this.item.addEventListener('focusout',this.onFocusOut);
      this.onOutside=(event)=>{if(!this.item.contains(event.target)&&!this.hasAttribute('hidden'))this.navigation.closeDropdown(this.item);};
      document.addEventListener('pointerdown',this.onOutside);
      this.observer=new MutationObserver(()=>{
        const isOpen=!this.hasAttribute('hidden');
        this.toggle.setAttribute('aria-expanded',String(isOpen));
        if(isOpen)this.navigation.querySelectorAll('[data-wgh-mega-item]').forEach(item=>{
          if(item!==this.item&&item.querySelector('.header__linklist-link')?.getAttribute('aria-expanded')==='true')this.navigation.closeDropdown(item);
        });
      });
      this.observer.observe(this,{attributes:true,attributeFilter:['hidden']});
    }
    disconnectedCallback(){this.observer?.disconnect();document.removeEventListener('pointerdown',this.onOutside);clearTimeout(this.focusTimer);clearTimeout(this.blurTimer);this.toggle?.removeEventListener('click',this.onToggle);this.item?.removeEventListener('keydown',this.onKey);this.item?.removeEventListener('focusout',this.onFocusOut);}
  });
}
  } catch(e) { console.error(e); }
})();

})();
